module.exports = __webpack_public_path__ + "media/images/yarn-a7a13fd43ec1adbcf56d577ea48dac75.png";